export const querykeys = {
  categories: "categories", // get all the categories
  category: "category", // get one category

  warehouses: "warehouses", // get all the warehouses
  warehouse: "warehouse", // get one warehouse

  products: "products", // get all the products
  product: "product", // get one product

  searchProducts: "searchProducts", // search products

  suppliers: "suppliers",
  supplier: "supplier",

  brands: "brands",
  brand: "brand",

  notifications: "notifications",
  notification: "notification",

  stockOrder: "stockOrder",
  stockOrders: "stockOrders",

  depositsReport: "depositsReport",
  disbursementReport: "disbursementReport",
  pendingPickups: "pendingPickups",
  pendingShipment: "pendingShipment",
  ordersMonthlyNetMarginReport: "ordersMonthlyNetMarginReport",
  ordersItemMonthlySummaryReport: "ordersItemMonthlySummaryReport",
  ordersTotalByMonthReport: "ordersTotalByMonthReport",
  ordersTotalKgReport: "ordersTotalKgReport",
  ordersTotalKgBySupplierReport: "ordersTotalKgBySupplierReport",
  ordersTotalSellsMonthReport: "ordersTotalSellsMonthReport",
  purchaseTotalPurchaseMonthReport: "purchaseTotalPurchaseMonthReport",
  treasuryTotalExpensesMonthReport: "treasuryTotalExpensesMonthReport",

  coupon: "coupon",
  coupons: "coupons",

  offer: "offer",
  offers: "offers",

  banks: "banks",
  bank: "bank",

  barcodes: "barcodes",
  barcode: "barcode",

  variants: "variants",
  variant: "variant",

  checks: "checks",
  check: "check",
  checksPortfolio: "checksPortfolio",

  masterdataBrands: "masterdataBrands",
  masterdataProducts: "masterdataProducts",

  business: "business",

  usuarios: "usuarios",
  usuario: "usuario",

  empleado: "empleado",
  empleados: "empleados",

  gasto: "gasto",
  gastos: "gastos",

  deudaInicial: "deudaInicial",
  deudasIniciales: "deudasIniciales",

  telefonos: "telefonos",

  inventario: "inventario",
  inventarios: "inventarios",

  suelto: "suelto",
  sueltos: "sueltos",

  bulkInventario: "bulkInventario",

  atributos: "attributes",

  precios: "precios",
  precio: "precio",

  listas: "listas",
  lista: "lista",

  plan: "plan",
  planes: "planes",

  planMayorista: "plan-mayorista",
  planesMayoristas: "planes-mayoristas",

  templates: "templates",

  productGroups: "productGroups", // grupos de productos (catalog.product_groups)
  productGroup: "productGroup", // el detalle de un grupo, con sus miembros

  consumptionGroups: "consumptionGroups", // grupos de consumo (catalog.consumption_groups)
  consumptionGroup: "consumptionGroup", // el detalle, con sus miembros
  repurchaseReminders: "repurchaseReminders", // la cola de reposicion
  template: "template",

  transferencias: "transferencias",
  transferencia: "transferencia",

  purchases: "compras",
  purchase: "compra",

  purchaseInitialDebt: "purchaseInitialDebt",
  purchasesInitialDebt: "purchasesInitialDebt",

  buyers: "buyers",
  buyer: "buyer",
  debtors: "debtors", // compradores con deuda pendiente (listado server-side)

  transactions: "transactions",
  transaction: "transaction",

  orders: "orders",
  order: "order",

  deposits: "deposits",
  deposit: "deposit",

  disbursements: "disbursements",
  disbursement: "disbursement",

  payables: "payables",
  payable: "payable",

  cashDesk: "cashDesk",

  allocations: "allocations",
  allocation: "allocation",

  shippingMethods: "shippingMethods",

  checkoutFees: "checkoutFees",

  masterDataCheckoutFees: "masterDataCheckoutFees",
  masterDataExpenses: "masterDataExpenses",

  reservations: "reservations",
  reservation: "reservation",

  reservables: "reservables",
  reservable: "reservable",

  services: "services",
  service: "service",

  availabilitySlots: "availabilitySlots",
  availabilitySlot: "availabilitySlot",
  availabilityExceptions: "availabilityExceptions",
  availabilityException: "availabilityException",
  cancellationPolicies: "cancellationPolicies",
  cancellationPolicy: "cancellationPolicy",
  availableSlots: "availableSlots",
  bookings: "bookings",
  booking: "booking",

  boards: "boards",
  board: "board",

  bigSuppliers: "bigSuppliers",
  bigSupplier: "bigSupplier",
  bigSupplierProducts: "bigSupplierProducts",
  pendingPriceUpdates: "pendingPriceUpdates",
  pendingPriceUpdate: "pendingPriceUpdate",

  b2bOrders: "b2bOrders",
  b2bOrder: "b2bOrder",

  bigSupplierWhitelistStatus: "bigSupplierWhitelistStatus",
  bigSupplierDispatchWarehouse: "bigSupplierDispatchWarehouse",
  bigSupplierDiscontinuedLinks: "bigSupplierDiscontinuedLinks",
  bigSupplierAgreements: "bigSupplierAgreements",
  bigSupplierPaymentRequests: "bigSupplierPaymentRequests",
  bigSupplierB2BPayments: "bigSupplierB2BPayments",
  bigSupplierPublishableProductIds: "bigSupplierPublishableProductIds",
  buyerConnections: "buyerConnections",
  priceUpdates: "priceUpdates",
};
